<template>
  <v-footer
    app
    absolute
    v-if="showFooter"
    class="pa-3 subtle"
    :style="{'bottom': '0'}"
  >
    <v-spacer></v-spacer>
    <v-img
      class="mr-3 hidden-sm-and-down"
      max-width="130"
      :src="require('@/assets/styles/themes/polygon/polygon_logo.png')"
    ></v-img>
    <div class="grey--text">COPYRIGHT © POLYGON {{ currentYear }}</div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    showFooter() {
      return !this.get(this.$route, 'meta.hideFooter')
    }
  }
}
</script>

<style lang="scss" scoped>
.subtle {
  background-color: rgba(var(--color-subtle), 1);
}
</style>
